import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { Layout, Affix, Modal, Typography, Button } from 'antd';
import { Helmet } from 'react-helmet';
import './App.css';
import './index.css';
import * as ROUTES from '../../../../routes';
import TokenContext from '../../../../store.js';
import { ThemeProvider } from 'styled-components';
// eslint-disable-next-line
import { darkTheme, GlobalStyle } from '../../../../themes';
import styles from './../../../HomeContainer/components/Home/home.module.sass';
import Cookies from 'cookies-js';
import cx from 'classnames';
import { LockOutlined } from '@ant-design/icons';
import LoginContainer from '../../../LoginContainer';
import ImpersonateUserContainer from '../../../ImpersonateUserContainer';
import IndicatorsContainer from '../../../IndicatorsContainer';
import FeedContainer from '../../../FeedContainer';
import SAFeedContainer from '../../../SAFeedContainer';
import ProfileContainer from '../../../ProfileContainer';
import SubscriptionContainer from '../../../SubscriptionContainer';
import HomeContainer from '../../../HomeContainer';
import IOCContainer from '../../../IOCContainer';
import ConfirmResetPasswordContainer from '../../../ConfirmResetPasswordContainer';
import ResetPasswordContainer from '../../../ResetPasswordContainer';
import ExploreContainer from '../../../ExploreContainer';
import ReverseAExploreRecipeContainer from '../../../ReverseAExploreRecipeContainer';
import IPDiversityExploreRecipeContainer from '../../../IPDiversityExploreRecipeContainer';
import ForwardAExploreRecipeContainer from '../../../ForwardAExploreRecipeContainer';
import SubdomainFinderExploreRecipeContainer from '../../../SubdomainFinderExploreRecipeContainer';
import LatestDNSRecordsExploreRecipeContainer from '../../../LatestDNSRecordsExploreRecipeContainer';
import HostingInfrastructureASNsExploreRecipeContainer from '../../../HostingInfrastructureASNsExploreRecipeContainer';
import HostingInfrastructureIPsExploreRecipeContainer from '../../../HostingInfrastructureIPsExploreRecipeContainer';
import ShadowITExploreRecipeContainer from '../../../ShadowITExploreRecipeContainer';
import DomainsOnServerExploreRecipeContainer from '../../../DomainsOnServerExploreRecipeContainer';
import DanglingDNSRecordsCountRecipeContainer from '../../../DanglingDNSRecordsCountRecipeContainer';
import DanglingDNSProtectionExploreRecipeContainer from '../../../DanglingDNSProtectionExploreRecipeContainer';
import NameServerChangesExploreRecipeContainer from '../../../NameServerChangesExploreRecipeContainer';
import TXTExploreRecipeContainer from '../../../TXTExploreRecipeContainer';
import QueryBuilderContainer from '../../../QueryBuilderContainer';
import SpoofingExploreRecipeContainer from '../../../SpoofingExploreRecipeContainer';
import NameInTXTExploreRecipeContainer from '../../../NameInTXTExploreRecipeContainer';
import ExploreResultContainer from '../../../ExploreResultContainer';
import EnrichmentContainer from '../../../EnrichmentContainer';
import EnrichmentLandingContainer from '../../../EnrichmentLandingContainer';
import OrganizationSettingsContainer from '../../../OrganizationSettingsContainer';
import AccountSettingsContainer from '../../../AccountSettingsContainer';
import DashboardContainer from '../../../DashboardContainer';
import PlaybooksContainer from '../../../PlaybooksContainer';
import CustomersContainer from '../../../CustomersContainer';
import CustomerUsersContainer from '../../../CustomerUsersContainer';
import ValidationToolContainer from '../../../ValidationToolContainer';
import PerformanceContainer from '../../../PerformanceContainer';
import FeedsReport from '../../../FeedsReportContainer';
import MonitoringContainer from '../../../MonitoringContainer';
import QueryHistoryContainer from '../../../QueryHistoryContainer';
import RegisterContainer from '../../../RegisterContainer';
import SPQLContainer from '../../../SPQLContainer';
import BlogContainer from '../../../BlogContainer';

import FilterSideBar from '../FilterSideBar';
import TopHeader from '../TopHeader';
import { showNotification } from '../../../../shared-components/Notifications';
import mixpanel from 'mixpanel-browser';
import DownloadContainer from '../../../DownloadContainer';
import APIResponseContainer from '../../../APIResponseContainer';
import LeftMenuSidebar from '../../../LeftMenuSidebarContainer';
import { useSelector } from 'react-redux';
import SourcesContainer from '../../../SourcesContainer';
import SourceManagementContainer from '../../../SourceManagementContainer';
import history from '../../../../redux/history';
import { Userpilot } from 'userpilot';
import ConfirmExtendSubscription from '../../../ConfirmExtendSubscriptionContainer';
import BulkDataFeedsContainer from '../../../BulkDataFeedsContainer';
import DataMarketplaceFeedsContainer from '../../../DataMarketplaceFeedsContainer';
import { startWebSocketConnection } from '../../../../redux/utils/websocket/startWebSocketConnection.js';
import { STATUS } from '../../../../redux/constants/index.js';

const { Content, Footer } = Layout;
const requestSpentModalExeptions = [
  '/subscription',
  '/customers',
  '/login',
  '/register',
  '/profile',
  '/account',
  '/organization',
  '/customers/impersonate',
  '/indicators',
  '/reset',
  '/reset/confirm',
];

function App(props) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const leftMenuOpened = useSelector(
    (state) => state.sidebar.leftMenuSideBarVisible,
  );
  const value = { token, setToken };
  const isHomePage = props.location.pathname === ROUTES.HOME;
  const isIOCPage = props.location.pathname === ROUTES.IOC;
  const [requestSpentModalOpen, setRequestSpentModalOpen] = useState(false);
  const { Title, Text } = Typography;

  useEffect(() => {
    const user_department = props?.user?.department_info?.name;
    mixpanel.identify(props?.user?.username);
    mixpanel.register({ role: [props?.user?.role] });
    mixpanel.set_group('company', props?.user?.organisation);
    if (user_department !== undefined) {
      mixpanel.add_group('department', user_department);
    }

    if (
      props?.user?.username &&
      props?.user?.subscription_info?.subscription_plan_name &&
      props?.user?.email &&
      props?.user?.first_name &&
      props?.user?.last_name &&
      props?.user?.date_joined &&
      props?.user?.organisation &&
      props?.user?.organisation_id
    ) {
      Userpilot.identify(props?.user?.username, {
        plan_type: props?.user?.subscription_info?.subscription_plan_name,
        email: props?.user?.email,
        first_name: props?.user?.first_name,
        last_name: props?.user?.last_name,
        created_at: props?.user?.date_joined,
        company: {
          id: props?.user?.organisation_id,
          name: props?.user?.organisation,
        },
      });
    }

    // TODO: move to login()?
    //props.loadFilters();
    //props.loadUser();
  }, [props?.user]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      props?.user?.username &&
      props?.user?.subscription_info?.subscription_plan_name &&
      props?.user?.email &&
      props?.user?.first_name &&
      props?.user?.last_name &&
      props?.user?.date_joined &&
      props?.user?.organisation &&
      props?.user?.organisation_id &&
      props?.websocketConnectionStatus !== WebSocket.OPEN &&
      props?.websocketConnectionStatus !== WebSocket.CONNECTING &&
      props?.auth?.token
    ) {
      // alert('start');
      startWebSocketConnection();
    }
  }, [props?.user]);

  useEffect(() => {
    if (
      props?.auth?.token &&
      props?.websocketConnectionStatus === WebSocket.CLOSED
    )
      setTimeout(() => {
        // alert('We should restart');
        startWebSocketConnection();
      }, 10000);
  }, [props?.websocketConnectionStatus]);

  useEffect(() => {
    props.resetRecipeStatus();
    if (requestSpentModalExeptions.includes(window.location.pathname)) {
      setRequestSpentModalOpen(false);
    }
    const isExploreResultsPage = window.location.href.includes(
      '/explore-result',
    );
    if (!isExploreResultsPage) {
      props.saveBreadCrumbs(null);
    }
    Userpilot.reload();
  }, [window.location.href]);

  useEffect(() => {
    if (requestSpentModalExeptions.includes(window.location.pathname)) {
      setRequestSpentModalOpen(false);
    } else {
      if (
        props.mySubscriptionPlan?.total_requests_left <= 0 ||
        props.mySubscriptionLimit <= 0
      ) {
        setRequestSpentModalOpen(true);
      }
    }
  }, [
    props.mySubscriptionPlan?.total_requests_left,
    props.mySubscriptionLimit,
  ]);

  const getModalContainer = () => {
    return document.getElementById('contentContainer');
  };

  return (
    <TokenContext.Provider value={value}>
      <ThemeProvider theme={darkTheme}>
        <GlobalStyle />
        <div className="App">
          <Helmet>
            <title></title>
            <meta property="og:title" content="Silent Push" />
            <meta
              property="og:description"
              content="Silent Push is a cloud based service to rank and filter intelligence and apply it to security infrastructure."
            />
          </Helmet>
          <Layout>
            {props.auth.token === '' ||
            !JSON.parse(Cookies.get('persist:refreshToken') || '{}')
              ?.refreshToken ||
            // props.auth.loginStatus === STATUS.ERROR ||
            isIOCPage ? (
              ''
            ) : (
              <TopHeader
                logout={props.logout}
                user={props.user}
                userStatus={props.userStatus}
              />
            )}
            {props.notification
              ? showNotification(props.notification, props.removeNotification)
              : null}
            <Layout>
              {leftMenuOpened &&
                props.auth.token !== '' &&
                JSON.parse(Cookies.get('persist:refreshToken') || '{}')
                  ?.refreshToken && <LeftMenuSidebar />}
              {isHomePage && <FilterSideBar />}

              <Layout
                className={cx(
                  styles.layoutContainer,
                  { [styles.not_collapsed]: !props.leftMenuSideBarCollapsed },
                  { [styles.requestsSpentMask]: requestSpentModalOpen },
                )}
                style={{
                  ...(window.location.href.includes('spql')
                    ? { padding: 0 }
                    : {}),
                }}
              >
                <Content
                  id="contentContainer"
                  className={styles.contentContainer}
                  style={{ marginTop: '64px', minHeight: 'calc(100vh - 60px)' }}
                >
                  <div
                    className={cx({
                      [styles.requestsSpent]: requestSpentModalOpen,
                    })}
                  >
                    <Route
                      exact
                      path={ROUTES.HOME}
                      component={
                        process.env.REACT_APP_FRONTEND_NODE_ENV === 'explore' ||
                        process.env.REACT_APP_FRONTEND_NODE_ENV ===
                          'dev-explore'
                          ? ExploreContainer
                          : HomeContainer
                      }
                    />
                    <Route exact path={ROUTES.IOC} component={IOCContainer} />
                    <Route
                      exact
                      path={ROUTES.LOGIN}
                      component={LoginContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.IMPERSONATE}
                      component={ImpersonateUserContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.INDICATORS}
                      component={IndicatorsContainer}
                    />
                    <Route exact path={ROUTES.FEED} component={FeedContainer} />
                    <Route
                      exact
                      path={ROUTES.FEED_SA}
                      component={SAFeedContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.PROFILE}
                      component={ProfileContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.SUBSCRIPTION}
                      component={SubscriptionContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.ACCOUNT}
                      component={AccountSettingsContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.ORGANIZATION}
                      component={OrganizationSettingsContainer}
                    />

                    <Route
                      exact
                      path={ROUTES.RESET_PASSWORD}
                      component={ResetPasswordContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.CONFIRM_RESET_PASSWORD}
                      component={ConfirmResetPasswordContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.CONFIRM_EXTEND_SUBSCRIPTION}
                      component={ConfirmExtendSubscription}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE}
                      component={ExploreContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.ENRICHMENT_LANDING}
                      component={EnrichmentLandingContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_DOMAINS_SERVER}
                      component={DomainsOnServerExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_DOMAINS_SERVER_SPECIFIC}
                      component={DomainsOnServerExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_DANGLING_DNS_PROTECTION}
                      component={DanglingDNSProtectionExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_DANGLING_DNS_PROTECTON_SPECIFIC}
                      component={DanglingDNSProtectionExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_NAME_SERVER_CHANGES}
                      component={NameServerChangesExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_NAME_SERVER_CHANGES_SPECIFIC}
                      component={NameServerChangesExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_REVERSE_A_QUERY}
                      component={ReverseAExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_REVERSE_A_QUERY_SPECIFIC}
                      component={ReverseAExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_TXT}
                      component={TXTExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_TXT_SPECIFIC}
                      component={TXTExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_QUERY_BUILDER}
                      component={QueryBuilderContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_QUERY_BUILDER_SPECIFIC}
                      component={QueryBuilderContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_FORWARD_A_QUERY}
                      component={ForwardAExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_FORWARD_A_QUERY_SPECIFIC}
                      component={ForwardAExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_HOSTING_INFRASTRUCTURE_ASNS}
                      component={
                        HostingInfrastructureASNsExploreRecipeContainer
                      }
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_HOSTING_INFRASTRUCTURE_ASNS_SPECIFIC}
                      component={
                        HostingInfrastructureASNsExploreRecipeContainer
                      }
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_DANGLING_DNS_RECOURDS_COUNT}
                      component={DanglingDNSRecordsCountRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_DANGLING_DNS_RECOURDS_COUNT_SPECIFIC}
                      component={DanglingDNSRecordsCountRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_HOSTING_INFRASTRUCTURE_IPS}
                      component={HostingInfrastructureIPsExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_HOSTING_INFRASTRUCTURE_IPS_SPECIFIC}
                      component={HostingInfrastructureIPsExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_SUBDOMAIN_FINDER}
                      component={SubdomainFinderExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_SUBDOMAIN_FINDER_SPECIFIC}
                      component={SubdomainFinderExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.LATEST_DNS_RECORDS}
                      component={LatestDNSRecordsExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_SHADOW_IT}
                      component={ShadowITExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_SHADOW_IT_SPECIFIC}
                      component={ShadowITExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_TYPOSQUATTING}
                      component={SpoofingExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_TYPOSQUATTING_SPECIFIC}
                      component={SpoofingExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_SPOOFING}
                      component={SpoofingExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_SPOOFING_SPECIFIC}
                      component={SpoofingExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.NAME_IN_TXT}
                      component={NameInTXTExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.NAME_IN_TXT_SPECIFIC}
                      component={NameInTXTExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_IP_DIVERSITY}
                      component={IPDiversityExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_IP_DIVERSITY_SPECIFIC}
                      component={IPDiversityExploreRecipeContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.EXPLORE_RESULT}
                      component={ExploreResultContainer}
                      key={props?.location?.search}
                    />
                    <Route
                      exact
                      path={ROUTES.BULK_DATA_FEEDS}
                      component={BulkDataFeedsContainer}
                      // key={props?.location?.search}
                    />
                    <Route
                      exact
                      path={ROUTES.DATA_MARKETPLACE_FEED}
                      component={DataMarketplaceFeedsContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.ENRICHMENT}
                      component={EnrichmentContainer}
                      //key={props?.location?.search}
                    />
                    <Route
                      exact
                      path={ROUTES.PLAYBOOKS}
                      component={PlaybooksContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.DASHBOARD}
                      component={DashboardContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.CUSTOMERS}
                      component={CustomersContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.CUSTOMER_USERS}
                      component={CustomerUsersContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.VALIDATION}
                      component={ValidationToolContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.PERFORMANCE}
                      component={PerformanceContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.FEED_REPORTS}
                      component={FeedsReport}
                    />
                    <Route
                      exact
                      path={ROUTES.SOURCES}
                      component={SourcesContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.SOURCE_MANAGEMENT}
                      component={SourceManagementContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.MONITORING}
                      component={MonitoringContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.QUERY_HISTORY}
                      component={QueryHistoryContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.WEB_SCANNER}
                      component={SPQLContainer}
                    />
                    <Route
                      exact
                      path={ROUTES.DOWNLOAD_CONTENT}
                      component={DownloadContainer}
                    />
                    <Route
                      path={ROUTES.API_RESPONSE}
                      component={APIResponseContainer}
                    />
                    <Route
                      path={ROUTES.REGISTER}
                      component={
                        (process.env.REACT_APP_FRONTEND_NODE_ENV ===
                          'explore' ||
                          process.env.REACT_APP_FRONTEND_NODE_ENV ===
                            'dev-explore') &&
                        RegisterContainer
                      }
                    />
                    <Route path={ROUTES.BLOG} component={BlogContainer} />
                  </div>
                </Content>

                <Modal
                  wrapClassName={cx(styles.requestSpentModal, {
                    [styles.notCollapsed]: !props.leftMenuSideBarCollapsed,
                  })}
                  closable={false}
                  footer={null}
                  maskClosable={false}
                  bodyStyle={{ padding: '3rem' }}
                  open={requestSpentModalOpen}
                  mask={false}
                  getContainer={getModalContainer}
                  centered
                >
                  <div className={styles.lockIcon}>
                    <LockOutlined />
                  </div>
                  <Title level={3}>Daily Request Limit Reached</Title>
                  <Text className={styles.message}>
                    You have reached your daily limit of{' '}
                    {props.mySubscriptionPlan?.requests_limit} requests. Please
                    try again tomorrow or upgrade your plan to increase your
                    limit.
                  </Text>
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => history.push('/subscription')}
                  >
                    View My Subscription
                  </Button>
                </Modal>

                <Footer className="footer noselect">
                  <div className="footer_left">
                    Silent Push Inc. ©{new Date().getFullYear()}
                  </div>
                  <div className="footer_right">Privacy Policy</div>
                </Footer>
              </Layout>
            </Layout>
          </Layout>
        </div>
      </ThemeProvider>
    </TokenContext.Provider>
  );
}

App.propTypes = {};

export default React.memo(withRouter(App));
